import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { IPermissionScope } from 'src/app/auth/auth.model';
import { AccessLevels } from '@bciti/types';
import { State } from '../../../store';
import { userScopesSelector } from 'src/app/user/store/user.selectors';

@Component({
    selector: 'app-request-dashboard',
    templateUrl: './request-dashboard.component.html',
    styleUrls: ['./request-dashboard.component.scss'],
})
export class RequestDashboardComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private userScopes: IPermissionScope[] = [];

    get canViewSettings(): boolean {
        return this.userScopes.some((scope) => scope.resource === 'settings' && scope.accessLevel === AccessLevels.WRITE);
    }

    constructor(private store: Store<State>) {}

    ngOnInit(): void {
        this.store
            .select(userScopesSelector)
            .pipe(takeUntil(this.destroy$))
            .subscribe((scopes: IPermissionScope[]) => {
                this.userScopes = scopes || [];
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
